import React from "react";
import styled from "styled-components";
import Loading from "common/Loading";
import HorizontalBarChart from "./HorizontalBarChart";
import {
  PERIOD_DASHBOARD_TO_HOURS,
  LOAD_INTERVAL,
  DPI_STATS_DASHBOARD_TMOUT_MS,
  RETURN_VIEW,
} from "./utils";
import useDashboardData from "./useDashboardData";
import { atBqnTarget } from "common/api";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;

  &:hover {
    cursor: pointer;
  }
`;

const WrapperLoader = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 250px;
  color: var(--text-primary);
`;

const getInternetSideLatency = ({ hours, mode, bqnId }) => {
  return ifCl
    .run(
      atBqnTarget(
        `show statistics dpi latency top hours ${hours} categories 10 all-subs all-internet`,
        mode,
        bqnId,
      ),
      { timeout: DPI_STATS_DASHBOARD_TMOUT_MS },
    )
    .then((response) => {
      const [header, ...rows] = response.trim().split("\n");
      if (!header) return [];
      const headerAttrs = header.trim().split(/\s+/);
      const items = rows
        .filter((row) => row.trim() !== "")
        .map((row) => {
          const rowAttrs = row.trim().split(/\s+/);
          const newEntry = rowAttrs.reduce((acc, attr, index) => {
            const attrName = headerAttrs[index];
            if (attrName === "CATEGORY") {
              acc.name = attr;
            }
            if (attrName === "UP-RTT-MS") {
              acc.value = Number(Number(attr).toFixed(2));
            }
            return acc;
          }, {});
          return newEntry;
        });
      return items;
    });
};

function InternetSideLatency({ period }) {
  const handleClick = (name) => {
    globalNavigate("viewDPILatency", {
      returnView: RETURN_VIEW,
      selectedApp: name,
    });
  };

  // The chart has a cadence of its own: it draws no range of the dashboard,
  // so nothing else asks for its data again.
  const { data, isLoading } = useDashboardData({
    retrieve: ({ mode, bqnId }) =>
      getInternetSideLatency({
        hours: PERIOD_DASHBOARD_TO_HOURS[period],
        mode,
        bqnId,
      }),
    onError: "Error fetching internet side latency data:",
    deps: [period],
    interval: LOAD_INTERVAL,
  });

  if (isLoading) {
    return (
      <WrapperLoader>
        <Loading />
      </WrapperLoader>
    );
  }

  if (!data || data.length === 0) {
    return <WrapperLoader>No data available</WrapperLoader>;
  }

  return (
    <Wrapper>
      <HorizontalBarChart
        data={data}
        height={240}
        margin={{ top: 0, right: 0, bottom: 0, left: 110 }}
        onClick={(name) => handleClick(name)}
      />
    </Wrapper>
  );
}

export default React.memo(InternetSideLatency);
